import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import {CaseHelperService} from 'src/app/ordering-platform/services/helpers/CaseHelperService';


@Component({
    selector: 'expired-draft-component',
    templateUrl: './expired-draft-dialog.component.html',
    styleUrls: ['./expired-draft-dialog.component.sass']
})
export class ExpiredDraftComponent {
    constructor(
        public dialogRef: MatDialogRef<ExpiredDraftComponent>,
        private _caseHelper: CaseHelperService,
    ) { 
        var self = this;
        var i = 0;
        this._caseHelper.expiredDrafts.forEach(od => {
            if(i>0){
                self.PolicyName += ", ";
            }
            self.PolicyName += od.productname ?? od.productName;

            i++;
        });

    }

    public PolicyName: string = "";

    cancel() {
        this.dialogRef.close(false);
    }

    newDraft() {
        this.dialogRef.close(true);
    }
}